export default __webpack_public_path__ + "profile-link_sm@2x.12c8d028.png";